import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { makeReextractUes } from "../../domain/use-cases/reextract-ues"
import { httpDocumentRepository } from "../../data/repositories/document-repository"
import {
  startDocumentUesPolling,
  stopDocumentUesPolling,
} from "./use-document-ues"

const reextractUes = makeReextractUes(httpDocumentRepository)

type ReextractUesParams = {
  docId: string
  docTypeId?: string | null
}

export const useReextractUes = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: ({ docId, docTypeId }: ReextractUesParams) =>
      reextractUes(docId, docTypeId),
    onMutate: ({ docId }) => {
      startDocumentUesPolling(docId)
    },
    onSuccess: (_, { docId }) => {
      toast.success("Re-extraction started")
      qc.invalidateQueries({ queryKey: ["documentUes", docId] })
    },
    onError: (_, { docId }) => {
      stopDocumentUesPolling(docId)
    },
  })
}
